
import { footer, skinCustom } from '../customWhiteLabel'
export default {
  data: () => ({
    formsContacts: {},
    loadingBtn: false,
    colorGradient: '',
    footer,
    skinCustom,
  }),
  head: {
    title: 'Contato',
  },

  methods: {
    sendContact() {
      const validate = this.$refs.form.validate()
      if (validate) {
        return false
      }
    },
  },
}
